export default "__VITE_ASSET__DJwmmK3c__"